"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12 17.799 22.5 12 22.5ZM9.766 7.309a1.787 1.787 0 1 1 3.574 0 1.787 1.787 0 0 1-3.574 0Zm3.521 3.401c-.032-.508-.357-.903-.865-.933A7.307 7.307 0 0 0 12 9.766h-1.564c-.261 0-.48.006-.662.016-.53.03-.884.42-.897.952a14.9 14.9 0 0 0 0 .745c.013.53.367.922.897.951a12.094 12.094 0 0 0 .887.015l-.001.449v2.693c-.568.012-.991.03-1.302.05-.488.03-.88.33-.917.818a6.256 6.256 0 0 0 0 .92c.036.488.429.789.917.819.518.031 1.35.061 2.642.061 1.291 0 2.123-.03 2.642-.061.488-.03.88-.331.917-.82a6.255 6.255 0 0 0 0-.919c-.036-.488-.429-.789-.917-.819-.31-.019-.734-.037-1.302-.049v-2.693c0-1.03-.025-1.725-.053-2.184Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgInformation);
var _default = exports["default"] = Memo;